import * as types from "./shared.types";

export const side_nav_set_open_tab = (tabId) => ({
	tab_id: tabId,
	type: types.SIDE_NAV_SET_OPEN_TAB,
});

export const side_nav_set_open_tab_item = (tabItemId) => ({
	tab_item_id: tabItemId,
	type: types.SIDE_NAV_SET_OPEN_TAB_ITEM,
});

export const set_theme = (theme) => ({
	payload: theme,
	type: types.SET_THEME,
});
